/**
 * Lithuanian vocative case (šauksmininkas) for first names.
 * Mirrors supabase/functions/_shared/lithuanian-vocative.ts — keep in sync.
 */
export function toVocative(name: string): string {
  if (!name) return name;
  const n = name.trim();
  const lower = n.toLowerCase();
  if (lower.endsWith("ė")) return n.slice(0, -1) + "e"; // Rimantė → Rimante, Eglė → Egle
  if (lower.endsWith("ius")) return n.slice(0, -3) + "iau"; // Marius → Mariau
  if (lower.endsWith("us")) return n.slice(0, -2) + "au"; // Vidus → Vidau
  if (lower.endsWith("as")) return n.slice(0, -2) + "ai"; // Povilas → Povilai
  if (lower.endsWith("ys")) return n.slice(0, -2) + "y"; // Stasys → Stasy
  if (lower.endsWith("is")) return n.slice(0, -2) + "i"; // Algis → Algi
  return n; // Rūta, Laima, užsienietiški — nesikeičia
}
